import { RegularReportHistoryPage } from "@/features/regular-document/pages/RegularHistory";

const RegularHistory = () => {
  return <RegularReportHistoryPage />;
};

export default RegularHistory;
